var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.00 101.00",
    "data-guides": "{\"vertical\":[],\"horizontal\":[]}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(209, 44, 31)",
    stroke: "none",
    fillOpacity: 1,
    strokeWidth: 1.7,
    strokeOpacity: 1,
    color: "rgb(51, 51, 51)",
    id: "tSvg16a6284e442",
    title: "Path 28",
    d: "M74.8472 26.8657C68.3147 35.2594 57.9639 43.907 55.2489 45.7721C53.8065 46.7047 52.7034 47.1284 51.5155 47.1283C50.4124 47.0434 49.2245 46.7042 47.7819 45.7713C44.9817 43.8206 34.7137 35.2555 28.1793 26.8604C21.8994 18.7197 25.3769 6.7645 34.625 2.4412C44.7217 -2.2213 51.5108 5.9196 51.5108 5.9196C51.5108 5.9196 51.5108 5.9196 51.5108 5.9196C51.5108 5.9196 51.5108 5.9196 51.5108 5.9196C51.5108 5.9196 58.2979 -2.2197 68.3957 2.445C77.645 6.7705 81.21 18.6417 74.8472 26.8657Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b8c5a",
    stroke: "none",
    fillOpacity: 1,
    strokeWidth: 1.7,
    strokeOpacity: 1,
    color: "rgb(51, 51, 51)",
    id: "tSvg1605a219644",
    title: "Path 29",
    d: "M76.3061 73.8912C67.8933 67.3541 59.2272 56.9942 57.3583 54.2766C56.4239 52.8329 55.9994 51.7286 56 50.5394C56.0856 49.4349 56.4263 48.2454 57.3621 46.8007C59.3189 43.9963 67.9102 33.7128 76.3296 27.1672C84.4939 20.8766 96.3938 24.4386 100.6397 33.6114C105.3104 43.7184 97.1459 50.5187 97.1459 50.5187C97.1459 50.5187 97.1459 50.5187 97.1459 50.5187C97.1459 50.5187 97.1459 50.5187 97.1459 50.5187C97.1459 50.5187 105.3035 57.3108 100.6228 67.4226C96.3675 76.7695 84.3791 80.2586 76.3061 73.8912Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b8c5a",
    stroke: "none",
    fillOpacity: 1,
    strokeWidth: 1.7,
    strokeOpacity: 1,
    color: "rgb(51, 51, 51)",
    id: "tSvg20278e12fa",
    title: "Path 30",
    d: "M68.4137 98.5616C58.3132 103.2208 51.5148 95.0704 51.5148 95.0704C51.5148 95.0704 51.5148 95.0704 51.5148 95.0704C51.5148 95.0704 51.5148 95.0704 51.5148 95.0704C51.5148 95.0704 44.7283 103.2107 34.6209 98.5366C25.363 94.2025 21.8731 82.4062 28.2349 74.1808C34.7665 65.7858 45.1186 57.139 47.8342 55.2744C49.2769 54.3422 50.3804 53.9188 51.5691 53.9196C52.6728 54.0053 53.8618 54.3455 55.3059 55.28C58.1093 57.2335 68.3893 65.8107 74.9334 74.2154C81.1376 82.4502 77.7501 94.3263 68.4137 98.5616Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b8c5a",
    stroke: "none",
    fillOpacity: 1,
    strokeWidth: 1.7,
    strokeOpacity: 1,
    color: "rgb(51, 51, 51)",
    id: "tSvg1130ebd8cef",
    title: "Path 31",
    d: "M2.4395 33.6588C-2.2228 43.7522 5.9332 50.546 5.9332 50.546C5.9332 50.546 5.9332 50.546 5.9332 50.546C5.9332 50.546 5.9332 50.546 5.9332 50.546C5.9332 50.546 -2.2127 57.3277 2.4646 67.4281C6.8017 76.6795 18.6063 80.167 26.8374 73.8096C35.2383 67.2826 43.8911 56.9378 45.757 54.2241C46.6899 52.7823 47.1135 51.6796 47.1127 50.4918C47.027 49.3887 46.6865 48.2006 45.7515 46.7575C43.7965 43.9561 35.2133 33.6832 26.8028 27.1437C18.5623 20.9438 6.6779 24.3289 2.4395 33.6588Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bbff7e913213b72b8b31b6fc854b82c.svg";
export { ForwardRef as ReactComponent };